import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './PaymentCancelPage.css';

function PaymentCancelPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();

  const handleRetry = () => {
    const orderId = searchParams.get('orderId');
    if (orderId) {
      navigate(`/payment/${orderId}`);
    } else {
      navigate('/orders');
    }
  };

  return (
    <div className="payment-cancel-page">
      <div className="container">
        <div className="cancel-card">
          <div className="cancel-icon">✕</div>
          <h1>支付已取消</h1>
          <p className="message">您已取消支付流程。如果您想继续支付，请点击下方按钮重试。</p>
          <div className="action-buttons">
            <button className="retry-button" onClick={handleRetry}>
              重新支付
            </button>
            <button className="back-button" onClick={() => navigate('/orders')}>
              返回訂單列表
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentCancelPage; 